/* eslint-disable */
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Subject } from "rxjs";

@Component({
    selector: "statistics-root-component",
    templateUrl: "./root.component.html",
    styleUrls: ["./root.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    //For some reason, if this facades are removed, the app broke
    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
